import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["href", "textContent"]

import { computed, onMounted, Ref, ref } from 'vue';
import { storeToRefs } from 'pinia';
import Chip from 'primevue/chip';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { useToast } from 'primevue/usetoast';
import { useStudentCaseManagerStore } from '@/store';
import { PERMISSIONS } from '@/enum';
import { can } from '@/composables';

interface CaseManagerPropsInterface {
  studentId?: number;
}

interface CaseManagerTableInterface {
  id: number;
  display_name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentCaseManagerTable',
  props: {
    studentId: {}
  },
  setup(__props: any) {

const props = __props;
const studentCaseManagerStore = useStudentCaseManagerStore();
const { caseManagersForStudentSelected: caseManagers, loading } = storeToRefs(studentCaseManagerStore);
const caseManagerCount: Ref<number> = computed(() => (caseManagers.value ? caseManagers.value.length : 0));
const caseManagerModalOpen = ref(false);
const addCaseManagerDataLoading = ref(false);
const toast = useToast();
const caseManagerItems: Ref<{ name: string; value: number }[]> = ref([]);

const refreshCaseManagers = () => studentCaseManagerStore.getCaseManagersForStudent(props.studentId as number);

onMounted(() => {
  if (can([PERMISSIONS.STUDENT_CASE_MANAGERS_INDEX])) refreshCaseManagers();
});

const createMenuModel = (item: CaseManagerTableInterface) => {
  return [
    {
      label: 'Remove Case Manager',
      command: () => {
        detachCaseManager([item.id], item.display_name);
      },
      visible: can([PERMISSIONS.STUDENT_DETACH_CASE_MANAGERS]),
    },
  ].filter((item) => item.visible);
};

const attachCaseManagers: (ids: number[]) => Promise<void> = async (ids) => {
  await studentCaseManagerStore.attachCaseManagers({ caseManagers: ids, studentId: props.studentId as number });
  await refreshCaseManagers();
  toast.add({
    severity: 'success',
    summary: 'Added',
    detail: 'Case Manager(s) has been added',
    life: 3000,
  });
};

const detachCaseManager: (ids: number[], caseManagerName: string) => Promise<void> = async (ids, caseManagerName) => {
  await studentCaseManagerStore.detachCaseManagers({ caseManagers: ids, studentId: props.studentId as number });
  await refreshCaseManagers();
  toast.add({
    severity: 'success',
    summary: 'Removed',
    detail: `Case Manager ${caseManagerName} has been removed from student`,
    life: 3000,
  });
};

const openAddCaseManagers = async () => {
  caseManagerItems.value = [];
  if (can([PERMISSIONS.STUDENT_CASE_MANAGERS_AVAILABLE_TO_ADD]) && can([PERMISSIONS.STUDENT_ATTACH_CASE_MANAGERS])) {
    addCaseManagerDataLoading.value = true;
    caseManagerModalOpen.value = true;
    caseManagerItems.value = await studentCaseManagerStore.getAddCaseManagersModalData(props.studentId as number);
    addCaseManagerDataLoading.value = false;
  } else {
    toast.add({
      severity: 'warning',
      summary: 'Error',
      detail: 'You do not have permission to add case managers',
      life: 3000,
    });
  }
};

const onCancelAdd = () => (caseManagerModalOpen.value = false);

const onSaveAdd = (caseManagers: { name: string; value: number }[]) => {
  const caseManagerIds = caseManagers.map((caseManager) => caseManager.value);
  attachCaseManagers(caseManagerIds);
  caseManagerModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Case Managers", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(caseManagerCount.value), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).STUDENT_ATTACH_CASE_MANAGERS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add Case Managers",
              "icon-left": "add",
              onClick: openAddCaseManagers
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _unref(caseManagers),
        "global-filter-fields": ['display_name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(loading),
        "data-key": "id",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-store-student-case-managers-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': _unref(loading) })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Case Managers not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (caseManagerCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, {
                  "body-class": "mw-20rem",
                  "header-class": "mw-20rem",
                  field: "display_name",
                  header: "Case Manager Name",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("a", {
                      class: "font-semibold",
                      href: `/user/${data.id}`,
                      textContent: _toDisplayString(data.display_name)
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column),
                _createVNode(_component_Column, {
                  "body-class": "justify-content-center mw-10rem",
                  "header-class": "justify-content-center mw-10rem",
                  field: "id",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    (createMenuModel(data).length > 0)
                      ? (_openBlock(), _createBlock(_component_ActionMenu, {
                          key: 0,
                          "menu-items": createMenuModel(data),
                          icon: "more_horiz"
                        }, null, 8, ["menu-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "class"]),
      (caseManagerModalOpen.value && _unref(can)([_unref(PERMISSIONS).STUDENT_CASE_MANAGERS_AVAILABLE_TO_ADD]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add Case Managers",
            "button-text": "Add Case Managers",
            placeholder: "Search case managers",
            loading: addCaseManagerDataLoading.value,
            items: caseManagerItems.value,
            searchable: true,
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd
          }, null, 8, ["loading", "items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})